import React from 'react';
import ReactDOM from 'react-dom/client';

import App from '@xtnd/admin/App';
import '@xtnd/admin/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
